// Program-scoped authoring access granted to a coordinator on a program detail
// screen (edrna_backend section:management:program).
// Delivered to the FE on the `coordinator_access` key of that response.
export type CoordinatorAccess = {
  user_id: string;
  /** the program master and its sections; nothing is inherited, so this is the whole scope */
  course_ids: string[];
};

export function inCoordinatorAccessScope(
  courseId: string | undefined,
  scope: CoordinatorAccess | null | undefined,
): boolean {
  if (!courseId || !scope) return false;
  return (scope.course_ids || []).includes(courseId);
}
